<template>
    <div id="rechargeDetail">
        <div>
            <div class="line">
                <label>订单号：</label>
                <div><span>{{ pkg.orderNo }}</span></div>                
            </div>
            <div class="line">
                <label>号码：</label>
                <div><span>{{ recordLoginText }}</span></div>                
            </div>
            <div class="line">
                <label>套餐名称：</label>
                <div><span>{{ pkg.packageName }}</span></div>                
            </div>
            <div class="line">
                <label>套餐类型：</label>
                <div><span>{{ pkg.investTypeName }}</span></div>                
            </div>
            <div class="line">                
                <label>支付方式：</label>
                <div><span>{{ pkg.payTypeName }}</span></div>                
            </div>
            <div class="line">
                <label>充值时间：</label>
                <div><span>{{ pkg.createTime }}</span></div>                
            </div>
            <div class="line">
                <label>金额：</label>
                <div><span>{{ pkg.priceRmb }} 元</span></div>                
            </div>
        </div>
    </div>    
</template>
<script>
export default {
    name: 'rechargeDetail',
    data(){
        return {
            pkg: '',
            recordLoginText: localStorage.getItem('recordLoginText')
        }
    },
    created(){
        this.pkg = this.$route.query;
    }
}
</script>
<style lang="less">
#rechargeDetail {
    padding: 10px 3%;
}
</style>
